import React from 'react';
import { Box, CircularProgress, Typography, useTheme } from '@mui/material';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  variant?: 'primary' | 'secondary';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  size = 'medium',
  fullScreen = false,
  variant = 'primary'
}) => {
  const theme = useTheme();

  const sizeMap = {
    small: 24,
    medium: 40,
    large: 60
  };

  const spinnerSize = sizeMap[size];
  const minHeight = fullScreen ? '100vh' : '400px';
  
  const color = variant === 'primary' 
    ? theme.palette.primary.main 
    : theme.palette.secondary.main;

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight={minHeight}
      gap={2}
      sx={{
        backgroundColor: fullScreen ? theme.palette.background.default : 'transparent',
        position: fullScreen ? 'fixed' : 'relative',
        top: fullScreen ? 0 : 'auto',
        left: fullScreen ? 0 : 'auto',
        right: fullScreen ? 0 : 'auto',
        bottom: fullScreen ? 0 : 'auto',
        zIndex: fullScreen ? theme.zIndex.modal : 'auto',
      }}
    >
      <CircularProgress 
        size={spinnerSize} 
        sx={{ color }}
        thickness={4}
      />
      {message && (
        <Typography 
          variant={size === 'large' ? 'h6' : 'body1'} 
          color="textSecondary"
          textAlign="center"
          sx={{ 
            fontWeight: size === 'large' ? 500 : 400,
            maxWidth: '300px'
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;